import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Plus } from "lucide-react";

export default function DashLayout({ children, title, action }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <header className="border-b border-gray-200 bg-white sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="dash-logo">
            <div className="w-7 h-7 bg-[#002FA7] grid place-items-center text-white font-display font-extrabold text-sm">Q</div>
            <span className="font-display font-extrabold tracking-tight text-lg">QAAB</span>
            <span className="label-eyebrow ml-3 hidden sm:inline">Owner console</span>
          </Link>
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium" data-testid="dash-user-name">{user?.full_name}</div>
              <div className="text-xs text-gray-500 font-mono">{user?.phone}</div>
            </div>
            <button
              onClick={() => { logout(); nav("/"); }}
              className="btn btn-ghost py-2 px-3 text-sm"
              data-testid="logout-button"
              title="Sign out"
            >
              <LogOut size={14} />
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-8 lg:py-12">
        <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
          <h1 className="font-display font-black text-4xl lg:text-5xl tracking-tight">{title}</h1>
          {action}
        </div>
        {children}
      </main>
    </div>
  );
}
